module.exports = __webpack_public_path__ + "img/background-code.96aa1239.svg";